import React from 'react';
import { Field } from 'formik';
import { Form, InputGroup } from 'react-bootstrap';

const ReactstrapFormikTextAreaCheckbox = ({
    field: { ...fields },
    form: { values, touched, errors, setFieldValue, setFieldTouched },
    ...props
}) => {
    const { id, ...rest } = props;
    const isCheckboxName = `is_${fields.name}`;
    return (
        <Form.Group controlId={id} className="form-group">
            {props.label && (
                <Field
                    name={isCheckboxName}
                    render={({ field }) => (
                        <div className="custom-control custom-checkbox">
                            <input
                                type="checkbox"
                                className="custom-control-input"
                                id={isCheckboxName}
                                checked={field.value}
                                {...field}
                                onChange={(e) => {
                                    if (!e.target.checked) {
                                        setFieldValue(fields.name, '');
                                    }
                                    setFieldValue(isCheckboxName, e.target.checked);
                                }}
                                onBlur={() => {
                                    setFieldTouched(isCheckboxName, true);
                                }}
                            />
                            <label className="custom-control-label pb-0" htmlFor={isCheckboxName}>
                                {props.label}
                            </label>
                        </div>
                    )}
                />
            )}
            <InputGroup>
                <Form.Control
                    {...fields}
                    {...rest}
                    as="textarea"
                    rows={props.rows || 1}
                    disabled={!values[isCheckboxName]}
                    isInvalid={Boolean(touched[fields.name] && errors[fields.name])}
                />
            </InputGroup>
            {touched[fields.name] && errors[fields.name] && errors[fields.name] !== 'required' && (
                <Form.Control.Feedback className="pb-0 error invalid-feedback d-block" type="invalid">
                    {errors[fields.name]}
                </Form.Control.Feedback>
            )}
        </Form.Group>
    );
};
export default ReactstrapFormikTextAreaCheckbox;
